import React, { useContext, useEffect, useState } from 'react';

import '../../../font.css';
import styled from 'styled-components';

import Title from '../../../components/Title';
import ContentsPreviewMobile from './ContentsPreviewMobile';
import ContentsPreviewH from './ContentsPreviewH';
import ContentsPreviewV from './ContentsPreviewV';
import {
  getContentsDetail,
  getSlideList,
} from '../../../modules/NetworkFunction';
import AuthContext from '../../../contexts/AuthContext';
import DrawerContents from '../../../components/DrawerContents';
import closeIcon from '../../../icons/ic-close.png';
import { ReactComponent as TipIcon } from '../../../icons/ic-tip.svg';

const PreviewPage = (props) => {
  const {
    closeModal,
    setPreviewModalClose,
    contentsNo,
    publishedContents = [],
    contentStyle,
    onSelectContentStyle = () => {},
    shopVersion,
    publishedContent
  } = props;
  const { auth: token } = useContext(AuthContext);
  console.log('Entered Preview Page')
  console.log('publishedContent: ', publishedContent)

  const [contentType, setContentType] = useState(
    publishedContent?.style || '배너 가로'
  );

  const [isMobile, setIsMobile] = useState(
    publishedContent?.mobileYn === 1 ? true : false
  );
  const [videoUrl, setVideoUrl] = useState(publishedContent?.videoURL);
  const [btnColor, setBtnColor] = useState(publishedContent?.btnColor);
  const [fontColor, setFontColor] = useState(publishedContent?.fontColor);
  const [font, setFont] = useState(publishedContent?.font);
  const [btnBorderRadius, setBtnBorderRadius] = useState(publishedContent?.borderRadius);
  const [slideList, setSlideList] = useState([]);
  const [margin, setMargin] = useState(publishedContent?.margin);

  const contents = { contentsNo: contentsNo };

  useEffect(() => {
    if (contentsNo) {
      getContentsDetail(
        contents,
        (e) => {
          console.log(e);
          setVideoUrl(e.videoURL);
        },
        () => {},
        (e) => {
          console.log(e);
        },
        token
      );
      getSlideList(
        contents,
        (error) => {
          console.log(error);
        },
        token
      ).then((response) => {
        setSlideList(
          response.data.slideList.sort((a, b) => a.displayTime - b.displayTime)
        );
      });
    }
    // 콘텐츠 만들기에서 미리보기
    else {
      setVideoUrl(props.videoUrl);
      setSlideList(props.slideList);
    }
  }, []);

  useEffect(() => {
    if (publishedContent === undefined || publishedContent === null) {
    console.log('publishedContents', publishedContents);
    console.log('contentStyle: ', contentStyle)
    if (publishedContents.length > 1) {
      if (isMobile) {
        publishedContents
          .filter((v) => v.mobileYn === 1)
          .forEach((v) => {
            setBtnColor(v.btnColor);
            setFontColor(v.fontColor);
            setBtnBorderRadius(v.borderRadius);
            setFont(v.font);
            setMargin(v.margin);
          });
      } else {
        publishedContents
          .filter((v) => v.mobileYn === 0)
          .forEach((v) => {
            setBtnColor(v.btnColor);
            setFontColor(v.fontColor);
            setBtnBorderRadius(v.borderRadius);
            setFont(v.font);
            setMargin(v.margin);
          });
      }
    } else if (publishedContents.length === 1) {
      setBtnColor(publishedContents[0].btnColor);
      setFontColor(publishedContents[0].fontColor);
      setBtnBorderRadius(publishedContents[0].borderRadius);
      setFont(publishedContents[0].font);
      setMargin(publishedContents[0].margin);
    }
  }
  }, [publishedContents, isMobile]);

  const previewMobile = (
    <div className="phone">
      <ContentsPreviewMobile
        key={contentType}
        videoUrl={videoUrl}
        slideList={slideList}
        btnColor={btnColor}
        fontColor={fontColor}
        font={font}
        btnBorderRadius={btnBorderRadius}
        contentsStyle={contentType}
        margin={margin}
      />
    </div>
  );

  const previewPC = (
    <div className="pc-preview">
      <div className="tab-bar"></div>
      <div
        className="pc-view"
        style={{
          backgroundColor: contentType.includes('팝업')
            ? 'rgba(0, 0, 0, 0.5)'
            : '#fff',
        }}
      >
        <div className="header">
          <p>W i z m o n</p>
          <div className="navbar">
            <ul>
              <li>NEW</li>
              <li>Coat</li>
              <li>Jacket</li>
              <li>Dress</li>
              <li>Sweater</li>
              <li>Top</li>
              <li>Pants</li>
              <li>Acc</li>
            </ul>
          </div>
        </div>
        <div className="main">
          <div
            className={
              contentType.includes('세로')
                ? 'contents-vertical'
                : 'contents-horizontal'
            }
          >
            {(contentType.includes('h') || contentType.includes('가로')) && (
              <ContentsPreviewH
                videoUrl={videoUrl}
                slideList={slideList}
                btnColor={btnColor}
                fontColor={fontColor}
                font={font}
                btnBorderRadius={btnBorderRadius}
                margin={margin}
                contentType={contentType}
              />
            )}
            {(contentType.includes('v') || contentType.includes('세로')) && (
              <ContentsPreviewV
                videoUrl={videoUrl}
                slideList={slideList}
                btnColor={btnColor}
                fontColor={fontColor}
                font={font}
                btnBorderRadius={btnBorderRadius}
                margin={margin}
                contentType={contentType}
              />
            )}
            {(contentType === 'drawer' || contentType === '서랍형')  && (
              <DrawerContents
                videoUrl={videoUrl}
                slideList={slideList}
                btnColor={btnColor}
                fontColor={fontColor}
                font={font}
                btnBorderRadius={btnBorderRadius}
                margin={margin}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );

  const renderPCVersionRadioBtns = () => {
    const types = [
      { value: 'popup_h', label: '팝업 가로' },
      { value: 'popup_v', label: '팝업 세로' },
      { value: 'banner_h', label: '배너 가로' },
      { value: 'banner_v', label: '배너 세로' },
      { value: 'drawer', label: '서랍형' },
    ];

    const handleSelectContentType = (type) => {
      console.log('type: ', type)
      setContentType(type);
      setIsMobile(false);
      if (shopVersion === 'pc') {
        onSelectContentStyle(type);
      }
    };

    return types.map((option) => {
      const isSelected = publishedContents?.some((v) => {
        return v.style === option.label && v.mobileYn === 0;
      });

      return (
        <div className="content-type-container" key={option.value}>
          <input
            className={`${option.value}_preview`}
            type="radio"
            id={option.value}
            value={option.value}
            checked={contentType === option.label && !isMobile}
            onChange={() => {
              handleSelectContentType(option.label);
            }}
          />
          <label htmlFor={option.value}></label>
          <p
            style={{
              color:
                contentType === option.label && !isMobile
                  ? '#FFB600'
                  : '#b5b5b5',
            }}
          >
            {option.label}
          </p>
          {isSelected && (
            <div
              onClick={() => {
                handleSelectContentType(option.label);
              }}
            >
              <SelectedBack />
              <Selected>선택됨</Selected>
            </div>
          )}
        </div>
      );
    });
  };

  const renderMobileVersionRadioBtns = () => {
    const types = [
      { value: 'popup_v_mobile', label: '팝업 세로' },
      { value: 'drawer_mobile', label: '서랍형' },
    ];

    const handleSelectContentType = (type) => {
      setContentType(type);
      setIsMobile(true);
      if (shopVersion === 'mobile') {
        onSelectContentStyle(type);
      }
    };

    return types.map((option) => {
      const isSelected = publishedContents?.some((v) => {
        return v.style === option.label && v.mobileYn === 1;
      });

      return (
        <div
          className="content-type-container"
          key={option.value}
          style={{ position: 'relative' }}
        >
          <input
            className={`${option.value}_preview`}
            type="radio"
            id={option.value}
            value={option.value}
            checked={contentType === option.label && isMobile}
            onChange={() => {
              handleSelectContentType(option.label);
            }}
          />
          <label htmlFor={option.value}></label>
          <p
            style={{
              color:
                contentType === option.label && isMobile
                  ? '#FFB600'
                  : '#b5b5b5',
            }}
          >
            {option.label}
          </p>
          {isSelected && (
            <div
              onClick={() => {
                handleSelectContentType(option.label);
              }}
            >
              <SelectedBack />
              <Selected>선택됨</Selected>
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div className="preview-page-modal">
      <div
        style={{
          width: '90%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        <Title title="미리보기" style={{ paddingTop: 66 }} />
        <CloseButton onClick={closeModal} />
        <div className="version-select-container">
          {(publishedContents.length < 1 || !isMobile) && (
            <div className="pc-version-container">
              <div className="version-title">PC 버전</div>
              <div className="radio-container">
                {renderPCVersionRadioBtns()}
              </div>
            </div>
          )}
          {(publishedContents.length < 1 || isMobile) && (
            <div className="mobile-version-container">
              <div className="version-title">모바일 버전</div>
              <div className="radio-container">
                {renderMobileVersionRadioBtns()}
              </div>
            </div>
          )}
          <div style={{ marginTop: '20px' }}>
            <div className="message-container">
              <div style={{ display: 'flex', gap: '4px' }}>
                <TipIcon />
                <p className="message">영상비율</p>
              </div>
              <div className="message-wrapper">
                <div>
                  <div className="message-titles">
                    <div className="message-title">16:9 가로 비율</div>
                  </div>
                  <div className="message-detail">
                    해당 콘텐츠 형태는 16:9 가로 비율 영상에 추천 드립니다.
                  </div>
                </div>
              </div>
              {/* 그외 Tip modal */}
            </div>
          </div>
          {/* 팝업형 */}
          {contentType.includes('팝업') && (
            <div className="message-container" style={{ marginBottom: '45px' }}>
              <div style={{ display: 'flex', gap: '4px' }}>
                <TipIcon />
                <p className="message">기존 쇼핑몰 디자인을 유지하고 싶다면?</p>
              </div>
              <div className="message-wrapper">
                <div>
                  <div className="message-titles">
                    <div className="message-title">팝업형</div>
                  </div>
                  <div className="message-detail">
                    기존 쇼핑몰 디자인을 유지하면서 위즈몬 배너 적용을 원하시는
                    경우 추천 드립니다.
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* 배너, 서랍형*/}
          {(contentType.includes('배너') || contentType.includes('서랍')) && (
            <div className="message-container" style={{ marginBottom: '45px' }}>
              <div style={{ display: 'flex', gap: '4px' }}>
                <TipIcon />
                <p className="message">새로운 쇼핑몰 디자인을 개발 중이라면?</p>
              </div>
              <div className="message-wrapper">
                <div>
                  <div className="message-titles">
                    <div className="message-title">배너형</div>
                    <div className="message-title">서랍형</div>
                  </div>
                  <div className="message-detail">
                    새로운 쇼핑몰을 개발 중이시라면 배너형, 서랍형 디자인 적용을
                    추천 드립니다.
                    <br /> 이외 다른 디자인도 적용해 보시고 최적의 광고 배너를
                    제작해보시기 바랍니다 :&#41;
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {isMobile ? previewMobile : previewPC}
      </div>

      {!contentsNo && (
        <div className="continue-btn">
          <button
            className="rounded-button-g"
            style={{
              backgroundColor: '#ffb600',
              width: 120,
              fontSize: 16,
              color: '#fff',
              padding: '7px 0px',
            }}
            onClick={() => {
              setPreviewModalClose();
            }}
          >
            <strong>계속하기</strong>
          </button>
        </div>
      )}
    </div>
  );
};

const Selected = styled.div`
  position: absolute;
  width: 54px;
  height: 24px;
  font-size: 12px;
  top: 33%;
  left: 25%;
  color: #fff;
  background-color: #f76f20;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 2px 4px;
`;

const SelectedBack = styled.div`
  position: absolute;
  width: 97px;
  height: 97px;
  top: 4%;
  left: 6%;
  color: #fff;
  background-color: rgba(255, 122, 0, 0.2);
  border-radius: 7.12px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  padding: 2px 4px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 60px;
  right: 0px;
  width: 32px;
  height: 32px;
  background-image: url(${closeIcon});
  background-color: transparent;
  background-size: 100% 100%;
`;

export default PreviewPage;
